import React, { createContext, useCallback, useState, useContext } from 'react';
import ExpenseTypeService from 'services/ExpenseTypeService';
import { AlertMessagesContext } from 'react-alert-messages';

export const ExpenseTypeContext = createContext();

function ExpenseTypeProvider({ children }) {
  const { postAlertMessage } = useContext(AlertMessagesContext);
  
  const [expenseTypes, setExpenseTypes] = useState(null);

  const fetchExpenseTypes = useCallback(async () => {
    try {
      const data = await ExpenseTypeService.getExpenseTypes();
      return data || [];
    } catch (error) {
      postAlertMessage?.({
        text: error.message || 'Failed to fetch expense types',
        type: 'failed',
        timeout: 5000,
      });
      return [];
    }
  }, [postAlertMessage]);

  const getExpenseTypes = useCallback(async () => {
    if (expenseTypes) {
      return expenseTypes;
    }
    const _expenseTypes = await fetchExpenseTypes();
    setExpenseTypes(_expenseTypes);
    return _expenseTypes;
  }, [fetchExpenseTypes, expenseTypes]);

  return (
    <ExpenseTypeContext.Provider
      value={{
        expenseTypes,
        getExpenseTypes,
        setExpenseTypes
      }}
    >
      {children}
    </ExpenseTypeContext.Provider>
  );
}

export default ExpenseTypeProvider;
